// TODO: fix eslint rules
import CryptoJS from 'crypto-js';
import { nanoid } from 'nanoid';
import { ContainerInstance, Service } from 'typedi';
import { type AppEnvironment } from '../config/app-environment';
import { EnvironmentService } from '../config/environment.service';
import { CookieName, CookiesService } from './cookies';

@Service()
export class EncryptionService {
  private readonly encryptionKey: string;

  constructor(container: ContainerInstance) {
    const { environment } = container.get(EnvironmentService<AppEnvironment>);
    const cookiesService = container.get(CookiesService);

    let tacoCookie = cookiesService.cookies.get(CookieName.TACO) as
      | string
      | undefined;
    if (!tacoCookie) {
      tacoCookie = nanoid();
      cookiesService.cookies.set(CookieName.TACO, tacoCookie, {
        path: '/',
        sameSite: 'strict',
      });
    }

    this.encryptionKey = `${tacoCookie}${environment.VITE_APP_PRAYER_STREAM_TACO}`;
  }

  decryptObject(encryptedValue: string): unknown {
    const decryptedBytes = CryptoJS.AES.decrypt(
      encryptedValue,
      this.encryptionKey,
    );

    if (!decryptedBytes.sigBytes) {
      throw new Error('Unable to decrypt value');
    }

    const decryptedValue = JSON.parse(
      decryptedBytes.toString(CryptoJS.enc.Utf8),
    );
    return decryptedValue;
  }

  encryptObject(value: Record<string, unknown>): string {
    const encryptedValue = CryptoJS.AES.encrypt(
      JSON.stringify(value),
      this.encryptionKey,
    ).toString();
    return encryptedValue;
  }
}
